import React from 'react';
import './HomieSustainability.css';
import OutlinedButton from './OutlinedButton.tsx';
import sustainabilityVideo from '../../250227_Sustainability Website Video_v4_Compressed.mp4';

const HomieSustainability: React.FC = () => {
  return (
    <section className="homie-sustainability">
      <video
        className="homie-sustainability__video"
        autoPlay
        loop
        muted
        playsInline
      >
        <source src={sustainabilityVideo} type="video/mp4" />
      </video>
      <div className="homie-sustainability__content">
        <h2 className="homie-sustainability__title">SUSTAINABILITY</h2>
        <div className="homie-sustainability__divider" />
        <p className="homie-sustainability__description">
          Our sustainable farming practices reduce our environmental impact, while producing the highest quality cannabis possible.
        </p>
        <div className="homie-sustainability__button">
          <OutlinedButton to="/sustainability">LEARN MORE ABOUT OUR GROW</OutlinedButton>
        </div>
      </div>
    </section>
  );
};

export default HomieSustainability;
